import { StyledTextControl } from "@dgs/core";
import styled from "styled-components";

export const ValueLabel = styled.div<StyledTextControl>`
	${({ theme }) => theme.forms.label};
	white-space: normal;
`;
